import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit } from '@angular/core';

@Component({
  selector: 'inc-device-select',
  templateUrl: './device-select.component.html',
  styleUrls: ['./device-select.component.scss'],
})
export class DeviceSelectComponent implements OnChanges, OnInit {
  @Input() label: string;
  @Input() placeholder: string;
  @Input() inList: { value: string, label: string }[];
  @Input() disabled: boolean;
  @Input() multiple: boolean;
  @Output() callSearch = new EventEmitter<string | string[]>();
  selectedValues: any;

  constructor() { }

  ngOnInit() {
    this.selectedValues = this.inList.map(list => list.value);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.multiple && !changes.multiple.previousValue && this.selectedValues === '') {
      this.selectedValues = this.inList.map(list => list.value);
    } else if ( changes.multiple && changes.multiple.previousValue && this.selectedValues.length === this.inList.length) {
      this.selectedValues = '';
    }
  }

  search(data: any) {
    if (data && data.detail) {
      this.callSearch.emit(data.detail.value instanceof Array ? (data.detail.value.length < this.inList.length && data.detail.value.length
        ? (data.detail.value as string[]) : '') : data.detail.value);
    }
  }
}
